import { render } from "./RequestsDetails.vue?vue&type=template&id=fcec8c2e&scoped=true"
import script from "./RequestsDetails.vue?vue&type=script&lang=js"
export * from "./RequestsDetails.vue?vue&type=script&lang=js"

import "./RequestsDetails.vue?vue&type=style&index=0&id=fcec8c2e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcec8c2e"]])

export default __exports__